import React, { useState, useEffect } from "react";
import {
  Row,
  Button,
  Input,
  Form,
  Col,
  Avatar,
  Spin,
  notification
} from "antd";
import classes from "../Settings.module.less";
import ChangePassword from "../../Dialogs/ChangePassword/ChangePassword";
import { getUserInfo, updateInfo } from "../../../services/acccountService";
import GetText from "../../UI/Text/Text";

const AccountSettings = ({ form }) => {
  const { getFieldDecorator } = form;
  const [display, setDisplay] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  useEffect(() => {
    fetch();
  }, []);

  const handleSubmit = event => {
    event.preventDefault();
    setUploading(true);
    form.validateFields(async (err, values) => {
      if (!err) {
        const { data } = await updateInfo(values);
        if (data.message === "success") {
          notification.success({
            message: <GetText id="informationUpdatedSuccess" />
          });
          setUploading(false);
        }
      }
    });
  };

  const fetch = async () => {
    try {
      setLoading(true);
      const { data } = await getUserInfo();
      setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const avatarStyle = { width: 120, height: 120, lineHeight: 64, fontSize: 32 };

  return (
    <div className={classes.container}>
      {loading ? (
        <Spin />
      ) : (
        <Row gutter={16}>
          <Col span={16}>
            <Form onSubmit={handleSubmit}>
              <Form.Item label={<GetText id="firstNameTitle" />}>
                {getFieldDecorator(`first_name`, {
                  rules: [{ required: true, message: "Required" }],
                  initialValue: data.first_name
                })(<Input />)}
              </Form.Item>
              <Form.Item label={<GetText id="lastNameTitle" />}>
                {getFieldDecorator(`last_name`, {
                  rules: [{ required: true, message: "Required" }],
                  initialValue: data.last_name
                })(<Input />)}
              </Form.Item>
              <Form.Item label={<GetText id="emailTitle" />}>
                {getFieldDecorator(`email`, {
                  rules: [{ required: true, message: "Required" }],
                  initialValue: data.email
                })(<Input disabled />)}
              </Form.Item>
              <Row style={{ paddingTop: 16 }} type="flex" justify="end">
                <Button
                  style={{ width: 150 }}
                  icon="save"
                  loading={uploading}
                  disable={uploading}
                  type="primary"
                  htmlType="submit"
                >
                  <GetText id="saveButton" />
                </Button>
                <Button
                  style={{ marginLeft: 20 }}
                  onClick={() => setDisplay(true)}
                  icon="edit"
                >
                  <GetText id="changePasswordButton" />
                </Button>
              </Row>
            </Form>
          </Col>
          <Col span={8} style={{ marginTop: 60 }}>
            <p>
              <GetText id="profileImageTitle" />
            </p>
            {localStorage.imageLocation ? (
              <Avatar src={localStorage.imageLocation} style={avatarStyle} />
            ) : (
              <Avatar style={avatarStyle} icon="user" />
            )}
          </Col>
        </Row>
      )}
      <ChangePassword display={display} close={() => setDisplay(false)} />
    </div>
  );
};

export default Form.create()(AccountSettings);
